import { useTranslation } from 'react-i18next';
import { CircleAlert } from 'lucide-react';
import { cn } from '@/lib/utils';
import UsageExpiredAlert from '@/components/billing/UsageExpiredAlert';
import { FREE_REGISTRATION_LIMIT } from '@/components/billing/FreeRegistrationLimitBanner';

type FreePlanUpsellBannerProps = {
  className?: string;
};

export default function FreePlanUpsellBanner({ className }: FreePlanUpsellBannerProps) {
  const { t } = useTranslation('billing');

  return (
    <div
      className={cn(
        'flex w-fit max-w-full items-center gap-2 rounded-[20px] border border-warning bg-warning-light py-2 pl-2 pr-4',
        className,
      )}
    >
      <CircleAlert className="size-6 shrink-0 text-warning" />
      <p className="text-center text-xs leading-4 text-dark font-base">
        <span className="font-semibold">
          {t('nonPayingBannerStrong', { max: FREE_REGISTRATION_LIMIT })}
        </span>{' '}
        {t('nonPayingBanner')}{' '}
        {/* Seul ce libellé est cliquable et ouvre la modale de choix de plan. */}
        <UsageExpiredAlert
          isConfig
          triggerLabel={t('nonPayingBannerCta')}
          triggerClassName="inline h-auto bg-transparent p-0 align-baseline text-xs leading-4 text-dark font-base underline shadow-none hover:bg-transparent"
        />{' '}
        {t('nonPayingBannerEnd')}
      </p>
    </div>
  );
}
